'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** syntactic sugar for using JSX syntax with ReactDOM.createPortal */
var Portal = function Portal(_ref) {
  var _ref$node = _ref.node,
      node = _ref$node === undefined ? document.body : _ref$node,
      children = _ref.children;
  return _reactDom2.default.createPortal(children, node);
};

exports.default = Portal;
//# sourceMappingURL=Portal.js.map